module.exports = __webpack_public_path__ + "img/activity.68848e31.png";